import { LS_AUTO_NEXT } from '../constants';
import { FETCH_AUTO_NEXT, SET_AUTO_NEXT } from './types';

///////////
// Add to list //
///////////

export function fetchAutoplayNext() {
    let request = true;
    if (localStorage.getItem(LS_AUTO_NEXT)){
        request = localStorage.getItem(LS_AUTO_NEXT) === 'true';
    }
    return {
        type: FETCH_AUTO_NEXT,
        payload: request
    };
}

export function setAutoplayNext(value) {
    localStorage.removeItem(LS_AUTO_NEXT);
    localStorage.setItem(LS_AUTO_NEXT,	value);

    return {
        type: SET_AUTO_NEXT,
        payload: value
    };
}
